@if (!processingONX) {
  <div class="mat-typography mat-body">
    <button mat-raised-button color="primary" id="enroll-plan-{{this.productName}}"
      [disabled]="!allowEnroll || !plan?.attributes?.PLAN_ID || (!enrollStartUrl && !plan?.attributes?.VENDOR_URL)"
      (click)="goToEnrollFlow()">
      <span>{{enrollButtonText}}</span>
    </button>
  </div>
} @else {
  <div class="spinner-container">
    <mat-spinner [diameter]="36"></mat-spinner>
  </div>
}
